const da = {
    nav: {
      home: "Hjem",
      browse: "Udforsk bryllupper",
      dashboard: "Dashboard",
      messages: "Beskeder",
      profile: "Profil",
      login: "Log ind",
      register: "Registrer",
      logout: "Log ud",
      admin: "Admin",
      faq: "FAQ",
      about: "Om os",
      contact: "Kontakt",
      pricing: "Priser",
      howItWorks: "Sådan fungerer det",
    },
    auth: {
      login: {
        title: "Velkommen tilbage",
        email: "E-mail",
        password: "Adgangskode",
        button: "Log ind",
        noAccount: "Har du ikke en konto?",
        register: "Tilmeld dig nu",
      },
      register: {
        title: "Opret konto",
        name: "Fulde navn",
        email: "E-mail",
        password: "Adgangskode",
        role: "Jeg vil...",
        roleHost: "Arrangere et bryllup",
        roleGuest: "Deltage i bryllupper",
        terms: "Jeg accepterer vilkårene og privatlivspolitikken",
        button: "Registrer",
        hasAccount: "Har du allerede en konto?",
        login: "Log ind nu",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Indlæser...",
      error: "Der opstod en fejl",
      success: "Succes",
      save: "Gem",
      cancel: "Annuller",
      delete: "Slet",
      edit: "Rediger",
      back: "Tilbage",
      next: "Næste",
      language: "Sprog",
      currency: "Valuta",
      search: "Søg",
      filter: "Filtrer",
      all: "Alle",
      none: "Ingen",
      yes: "Ja",
      no: "Nej",
    },
    footer: {
      about: "Om os",
      privacy: "Privatliv",
      terms: "Vilkår",
      contact: "Kontakt",
      copyright: "© 2024 WEDVAYA. Alle rettigheder forbeholdes.",
    },
  };

export default da;
